import { render, staticRenderFns } from "./SectionNav.vue?vue&type=template&id=48843908&"
import script from "./SectionNav.vue?vue&type=script&lang=js&"
export * from "./SectionNav.vue?vue&type=script&lang=js&"
import style0 from "./SectionNav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports